import {BaseDTO} from '../../common/models/BaseDTO';
import {CaseStatusDTO} from './CaseStatusDTO';

export class CaseStatusLinkDTO extends BaseDTO {
  caseStatusDTO: CaseStatusDTO;
  startDate: Date;
  endDate: Date;

  // Used by FE
  historyDisplayString?: string;
}
